// Third-party
import React, { ReactElement } from 'react';
import classNames from 'classnames';
import Nullable from '@/types/nullable';

type Props = {
  className?: string;
  selected: Nullable<string | number>;
  onChange: (value: any) => void;
  children: ReactElement | ReactElement[];
  dark?: boolean;
  disabled?: boolean;
  role?: React.AriaRole;
  onKeyDown?: (event: React.KeyboardEvent) => void;
};

const Tabs = ({ className, selected = null, onChange = () => {}, onKeyDown, dark, disabled, children, role = 'tablist' }: Props) => {
  const onItemClick = (value: any) => {
    if (selected !== value) {
      onChange(value);
    }
  };

  const classes = classNames('tabs', className, { dark }, { disabled });

  return (
    <ul className={classes} role={role} onKeyDown={onKeyDown}>
      {React.Children.map(children, child =>
        React.cloneElement(child, {
          className: classNames({ selected: selected === child.props.value, disabled: child.props.disabled }),
          onClick: !disabled ? onItemClick : undefined,
        }),
      )}
    </ul>
  );
};

export default Tabs;
